function init(Swiper, VisSenseFactory) {
  var containers = document.querySelectorAll('.js-swiper-container')

  ;[].forEach.call(containers, function (container) {
    var pagination = container.querySelector('.js-swiper-pagination')
    var itemsCount = +container.dataset.itemsCount
    var slidesCount = container.querySelectorAll('.com-sec-slider-3__slide').length

    var sliderSwiper = new Swiper(container, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
          return slidesCount > 3
            ? '<span class="com-sec-slider-3__pagination-item ' +
                className +
                '">' +
                '<span class="com-sec-slider-3__pagination-element"></span>' +
                '</span>'
            : ''
        },
      },
      loop: false,
      centerInsufficientSlides: true,
      speed: 700,
      breakpoints: {
        479: {
          slidesPerView: itemsCount ? itemsCount : 5,
          slidesPerGroup: itemsCount ? itemsCount : 5,
          pagination: {
            el: pagination,
            clickable: true,
            renderBullet: function (index, className) {
              return slidesCount > 5
                ? '<span class="com-sec-slider-3__pagination-item ' +
                    className +
                    '">' +
                    '<span class="com-sec-slider-3__pagination-element"></span>' +
                    '</span>'
                : ''
            },
          },
        },
      },
    })

    var section = document.querySelector('.com-sec-slider-3')

    var VisSense = VisSenseFactory(window)
    var visibility = VisSense(section, {fullyvisible: 0.6})

    visibility
      .monitor({
        fullyvisible: function () {
          if (scroll) {
            sliderSwiper.autoplay.start()
            scroll = false
          }
        },
      })
      .start()
  })
}

export default {
  init: async () => {
    var isBrowser = typeof window !== 'undefined'

    if (isBrowser) {
      const {default: Swiper, Navigation, Pagination, Autoplay} = await import('swiper')

      Swiper.use([Navigation, Pagination, Autoplay])

      const {default: VisSenseFactory} = await import('vissense')

      init(Swiper, VisSenseFactory)
    }
  },
}
